module.exports = "/next-static/_next/static/images/complexInstallAndSetup-406d0167b26f43909731af4fe6dcd825.png";